"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageUrl = exports.getPageType = exports.getCookieId = void 0;
var _cookie = require("../../utils/cookie");
var _log = require("./log");
/**
 * 异常case 
 * game.zhuanzhuan.58.com-buy-1074156344283267088
 * game.zhuanzhuan.com-detail-1001305593547096579
 * m.zhuanzhuan.58.com-Mzhuanzhuan-zhuanzhuan-zzactivity-magic-5a1bbec8d579804397f2de6b-index.html
 * m.zhuanzhuan.com-u-bmmain-auctionroom-300000000000104141
 * m.zhuanzhuan.com-u-bmmain-auctionroom-300000000000101341
 */
/**
 * @function getPageType
 * @description 获取页面类型, 后续统一用 pageId 代替
 * @return {string}
 */
var getPageType = function getPageType() {
  try {
    var pagetype = location.hostname.replace('m2.', 'm.');
    var pathname = location.pathname;
    var hash = location.hash;

    // 判断是否是魔方的项目
    if (pathname && pathname.indexOf('Mzhuanzhuan/zhuanzhuan/zzactivity') !== -1) {
      try {
        pagetype = "m.zhuanzhuan.com-Mzhuanzhuan-zhuanzhuan_zzactivity_magic-/".concat(location.href.match(/magic\/([0-9a-zA-Z]{18,})\/index.html/)[1], "/index.html");
      } catch (error) {
        pagetype = 'm.zhuanzhuan.com-Mzhuanzhuan-zhuanzhuan_zzactivity_magic-/MzhuanzhuanError/index.html';
      }
    } else {
      if (pathname && pathname !== '/') {
        pathname.split('/').forEach(function (v) {
          if (v !== '' && v !== '__defHashRooter__') {
            v = v.replace(/^[0-9a-zA-Z]{18,}$/, ':id').replace(/^[0-9]{5,}$/, ':id').replace('undefined', ':id').replace('index_sonic', 'index');
            // 如果包含汉字替换成search
            if (/[\u4e00-\u9fa5]/g.test(v)) {
              v = ':search';
            }
            pagetype += '-' + v.replace(/-/g, '_');
          }
        });
      }
    }
    var hashStr = '';
    if (hash) {
      hash = hash.replace(/\?.*/, '').replace(/^#/, '');
      hash.split('/').forEach(function (v) {
        if (v !== '') {
          v = v.replace(/^[0-9a-zA-Z]{18,}$/, ':id').replace(/^[0-9]{5,}$/, ':id').replace('undefined', ':id');
          // 如果包含汉字替换成search
          if (/[\u4e00-\u9fa5]/g.test(decodeURI(v))) {
            v = ':search';
          }
          if (/rent-order-detail/.test(hash) || /personallevelexplain/.test(hash)) {
            v = v.replace(/^[0-9]{1}$/, ':id');
          }
          if (v !== '__defHashRooter__') {
            hashStr += '/' + v.replace(/-/g, '_');
          }
        }
      });
    }
    pagetype = hashStr ? pagetype + '-' + hashStr : pagetype;
    // 过滤掉 pagetype 超长的脏数据
    if (pagetype.length > 200) {
      throw Error(pagetype);
    }
    return pagetype;
  } catch (err) {
    (0, _log.LogError)(err);
    return '';
  }
};

/**
 * 获取精简版 url， 后续用 pageId 代替
 */
exports.getPageType = getPageType;
var getPageUrl = function getPageUrl() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    var needScheme = opt.needScheme;
    var _window$location = window.location,
      protocol = _window$location.protocol,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname,
      hash = _window$location.hash;
    var url = hostname + pathname + "".concat(hash && hash.split('?')[0]);
    needScheme && (url = protocol + '//' + url);
    return url;
  } catch (e) {
    console.log(e);
    return '';
  }
};

/**
 * 获取用户 uid
 */
exports.getPageUrl = getPageUrl;
var getCookieId = function getCookieId() {
  return (0, _cookie.getCookie)('uid') || (0, _cookie.getPPU)().UID || (0, _cookie.getCookie)('kid') || (0, _cookie.getCookie)('idzz') || (0, _cookie.getCookie)('id58') || (0, _cookie.getCookie)('uuid') || (0, _cookie.getCookie)('58uuid') || '';
};
exports.getCookieId = getCookieId;